import { MANUFACTURING_TERMINAL_STATUS_IDS } from './terminal-status-ids.js';
/** Whether a job is worth offering Cancel on — narrower than the mutation, which still accepts CANCELLED. */
export function canCancelManufacturingOrder(statusId) {
    return statusId != null && !MANUFACTURING_TERMINAL_STATUS_IDS.includes(statusId);
}
//# sourceMappingURL=can-cancel-manufacturing-order.js.map